"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DashboardLayoutItemRenderer = void 0;
var tslib_1 = require("tslib");
// (C) 2007-2020 GoodData Corporation
var react_1 = tslib_1.__importStar(require("react"));
var react_grid_system_1 = require("react-grid-system");
var isNil_1 = tslib_1.__importDefault(require("lodash/isNil"));
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var isHiddenStyle = { height: 0, width: 0, overflow: "hidden", flex: 0 };
exports.DashboardLayoutItemRenderer = function (props) {
    var _a;
    var _b, _c, _d, _e, _f;
    var item = props.item, screen = props.screen, children = props.children, className = props.className, _g = props.minHeight, minHeight = _g === void 0 ? 0 : _g, isHidden = props.isHidden;
    var size = item.size();
    var currentScreenSizeConfiguration = item.sizeForScreen(screen);
    var ratio = currentScreenSizeConfiguration === null || currentScreenSizeConfiguration === void 0 ? void 0 : currentScreenSizeConfiguration.heightAsRatio;
    var height = currentScreenSizeConfiguration === null || currentScreenSizeConfiguration === void 0 ? void 0 : currentScreenSizeConfiguration.gridHeight;
    var width = currentScreenSizeConfiguration === null || currentScreenSizeConfiguration === void 0 ? void 0 : currentScreenSizeConfiguration.gridWidth;
    var style = react_1.useMemo(function () {
        var computedStyle = {
            minHeight: minHeight,
        };
        if (isHidden) {
            computedStyle = tslib_1.__assign(tslib_1.__assign({}, computedStyle), isHiddenStyle);
        }
        return computedStyle;
    }, [minHeight, isHidden]);
    return (react_1.default.createElement(react_grid_system_1.Col, { xl: (_b = size === null || size === void 0 ? void 0 : size.xl) === null || _b === void 0 ? void 0 : _b.gridWidth, lg: (_c = size === null || size === void 0 ? void 0 : size.lg) === null || _c === void 0 ? void 0 : _c.gridWidth, md: (_d = size === null || size === void 0 ? void 0 : size.md) === null || _d === void 0 ? void 0 : _d.gridWidth, sm: (_e = size === null || size === void 0 ? void 0 : size.sm) === null || _e === void 0 ? void 0 : _e.gridWidth, xs: (_f = size === null || size === void 0 ? void 0 : size.xs) === null || _f === void 0 ? void 0 : _f.gridWidth, className: classnames_1.default("gd-fluidlayout-column", "s-fluid-layout-column", "s-fluid-layout-screen-" + screen, "s-fluid-layout-column-width-" + width, (_a = {},
            _a["s-fluid-layout-column-ratio-" + ratio] = !isNil_1.default(ratio),
            _a["s-fluid-layout-column-height-" + height] = !isNil_1.default(height),
            _a), className), style: style }, children));
};
//# sourceMappingURL=DashboardLayoutItemRenderer.js.map